import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import {
  EscrowRefundEstimateConversionElementModel,
  EscrowRefundEstimateConversionElementDto,
  EscrowRefundEstimateElementDto,
  EscrowRefundEstimateElementModel,
  EscrowRefundEstimateBeforeConversionDto,
  EscrowRefundEstimateBeforeConversionModel,
  EscrowRefundEstimateDto,
  EscrowRefundEstimateModel,
  EscrowRefundEstimateResponse,
} from '../types/escrow-refund-estimate'
import { transformRefundEstimateBeforeConversionExchangeDto } from './refund-estimate'

export const transformEscrowRefundEstimateConversionElementDto = (
  item: EscrowRefundEstimateConversionElementDto,
): EscrowRefundEstimateConversionElementModel => ({
  title: item.title,
  ...(item.subtitle ? { subtitle: item.subtitle } : {}),
  money: transformCurrencyAmountDto(item.money),
  error: item.error,
})

export const transformEscrowRefundEstimateElementDto = (
  item: EscrowRefundEstimateElementDto,
): EscrowRefundEstimateElementModel => ({
  title: item.title,
  money: transformCurrencyAmountDto(item.money),
  type: item.type,
  error: item.error,
})

export const transformEscrowRefundEstimateBeforeConversionDto = (
  item: EscrowRefundEstimateBeforeConversionDto,
): EscrowRefundEstimateBeforeConversionModel => ({
  conversionElements: item.conversion_elements.map(
    transformEscrowRefundEstimateConversionElementDto,
  ),
  exchange: transformRefundEstimateBeforeConversionExchangeDto(item.exchange),
  markup: item.markup,
})

export const transformEscrowRefundEstimateDto = (
  item: EscrowRefundEstimateDto,
): EscrowRefundEstimateModel => ({
  totalEstimatedRefund: transformCurrencyAmountDto(item.total_estimated_refund),
  refundElements: item.refund_elements.map(transformEscrowRefundEstimateElementDto),
  beforeConversion: item.before_conversion
    ? transformEscrowRefundEstimateBeforeConversionDto(item.before_conversion)
    : null,
})

export const transformEscrowRefundEstimateResp = (response: EscrowRefundEstimateResponse) =>
  response.estimated_refund ? transformEscrowRefundEstimateDto(response.estimated_refund) : null
